import { getValueFromObjectByPrefix, arrayWithoutDublicates, menuFromData, $$ } from '../utils';
import { socialNetworks, linkModifiers } from '../data/constants.js';
import css from './footer/desktop.scss';
import htmlMobile from './footer/mobile';
import htmlDesktop from './footer/desktop';
import { footerMenuData } from '../data/footer';
import { modifyLangOnlyLinks, modifyLinks } from './common';

const { localizedSocialNetworks } = linkModifiers;

const icons = arrayWithoutDublicates(socialNetworks).reduce(
  (object, name) => Object.assign(object, { [name]: require(`./svg/${name}`).default }),
  {},
);

function getSocialLinks(t, tLinks, language) {
  return socialNetworks.map(network => ({
    extraContent: icons[network],
    name: network,
    href:
      localizedSocialNetworks[network] && localizedSocialNetworks[network][language]
        ? localizedSocialNetworks[network][language]
        : tLinks(network),
    classes: `${css.icon} ${css[`icon-inline-${network}`]}`,
    contentAttrs: { target: '_blank', 'aria-label': network },
  }));
}

export function removeHiddenClassHackForEditorsSites() {
  const classToRemove = 'hiddenTillReady';
  const footerIdToExclude = 'SITE_FOOTER';

  const destinationFooter = $$('footer').find(footer => !footer.id.includes(footerIdToExclude));
  const hidingElement = destinationFooter && destinationFooter.closest(`.${classToRemove}`);

  if (hidingElement) {
    hidingElement.classList.remove(classToRemove);
    hidingElement.style.display = 'block';
  }
}

export default ({ translations, isMobile, config, user, experiments }) => {
  const t = getValueFromObjectByPrefix(translations, 'footer_');
  const tAll = getValueFromObjectByPrefix(translations);
  const tLinks = getValueFromObjectByPrefix(translations, 'link_');
  const socialLinks = getSocialLinks(t, tLinks, config.language);

  const mainLinks = menuFromData(
    footerMenuData.nav,
    translations,
    config.language,
    [modifyLangOnlyLinks, modifyLinks(user)],
    tAll,
  );

  return { true: htmlMobile, false: htmlDesktop }[isMobile]({ mainLinks, socialLinks, t, config, tAll, experiments });
};
